/**
 * Get user avatar image. Do not forget to register a cleanup function to avoid memory leaks
 * @param email The email of the user
 * @param msftAccessToken The MSFT access token
 * @returns object: { countryOrRegion: string, officeLocation: string };
 */
export const getUserImage = (email: string, msftAccessToken: string) => {
    const apiURL = `https://graph.microsoft.com/beta/users/${email}/photo/$value`;

    return fetch(apiURL, {
        method: 'GET',
        headers: {
            Authorization: `Bearer ${msftAccessToken}`,
            Accept: '*/*'
        },
        mode: 'cors',
        cache: 'default',
    })
        .then(response => {
            if (!response.ok) {
                // Image does not exist
                return null;
            }

            return response.blob();
        })
        .then(imageBlob => (imageBlob ? URL.createObjectURL(imageBlob) : null));
};
